/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordResetConfirmRequest
 */
export interface PasswordResetConfirmRequest {
    /**
     * 
     */
    token: string;
    /**
     * 
     */
    password: string;
}

/**
 * Check if a given object implements the PasswordResetConfirmRequest interface.
 */
export function instanceOfPasswordResetConfirmRequest(value: object): value is PasswordResetConfirmRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function PasswordResetConfirmRequestFromJSON(json: any): PasswordResetConfirmRequest {
    return PasswordResetConfirmRequestFromJSONTyped(json, false);
}

export function PasswordResetConfirmRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetConfirmRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'password': json['password'],
    };
}

export function PasswordResetConfirmRequestToJSON(json: any): PasswordResetConfirmRequest {
    return PasswordResetConfirmRequestToJSONTyped(json, false);
}

export function PasswordResetConfirmRequestToJSONTyped(value?: PasswordResetConfirmRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'password': value['password'],
    };
}

